import Buefy from 'buefy'
import CKEditor from 'ckeditor4-vue'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import ApiService from './common/api.service'
import NotificationPlugin from './plugins/notification.plugin.js'
import router from './router'
import store from './store'

window.Vue = Vue

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowAltCircleRight,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsAlt,
  faBackward,
  faBookmark,
  faCalendar,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCircleNotch,
  faClipboard,
  faClipboardCheck,
  faCog,
  faCompressAlt,
  faSync,
  faCopy,
  faDiceD6,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFilePdf,
  faFlag,
  faForward,
  faFrown,
  faGripHorizontal,
  faIdBadge,
  faInfo,
  faLayerGroup,
  faLink,
  faList,
  faListAlt,
  faLock,
  faMinus,
  faPaperPlane,
  faPauseCircle,
  faPen,
  faPencilAlt,
  faPencilRuler,
  faPlay,
  faPlus,
  faPlusCircle,
  faPoll,
  faPuzzlePiece,
  faSave,
  faSearch,
  faShare,
  faSort,
  faSpinner,
  faStar,
  faTag,
  faTasks,
  faThLarge,
  faTimes,
  faTimesCircle,
  faTrash,
  faUndoAlt,
  faUpload,
  faUserEdit,
  faUserFriends,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { email, required } from 'vee-validate/dist/rules'
import VueLazyload from 'vue-lazyload'

import {
  faCheckSquare,
  faMinusSquare,
  faPlusSquare,
  faSquare,
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faEnvelope,
  faLock,
  faPlus,
  faCalendar,
  faSave,
  faSync,
  faEye,
  faEyeSlash,
  faArrowUp,
  faAngleLeft,
  faAngleRight,
  faTimesCircle,
  faUserEdit,
  faFileImport,
  faFileExport,
  faSearch,
  faUpload,
  faArrowRight,
  faTimes,
  faTrash,
  faInfo,
  faPoll,
  faForward,
  faBackward,
  faExclamationCircle,
  faCheck,
  faFileExcel,
  faFrown,
  faPen,
  faCopy,
  faArrowsAlt,
  faCaretDown,
  faCaretUp,
  faFilePdf,
  faPencilRuler,
  faMinus,
  faFlag,
  faCaretDown,
  faCaretUp,
  faEdit,
  faArrowAltCircleRight,
  faClipboard,
  faArrowLeft,
  faTag,
  faSpinner,
  faGripHorizontal,
  faEllipsisV,
  faChartBar,
  faClipboard,
  faDiceD6,
  faPuzzlePiece,
  faCircleNotch,
  faPlay,
  faUserFriends,
  faUsers,
  faList,
  faIdBadge,
  faCog,
  faPencilAlt,
  faEye,
  faLink,
  faCopy,
  faPlusCircle,
  faPencilAlt,
  faArchive,
  faUndoAlt,
  faShare,
  faSort,
  faStar,
  faClipboardCheck,
  faTasks,
  faPaperPlane,
  faCheckCircle,
  faPlusSquare,
  faMinusSquare,
  faBookmark,
  faListAlt,
  faLayerGroup,
  faThLarge,
  faDownload,
  faPauseCircle,
  faExternalLinkAlt,
  faCompressAlt,
  faSquare,
  faCheckSquare
)

Vue.component('vue-fontawesome', FontAwesomeIcon)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.config.productionTip = false

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
})

Vue.use(CKEditor)
Vue.use(VueClipboard)
Vue.use(VueLazyload)
extend('email', {
  ...email,
  message:
    'Pada bagian ini jawaban harus berupa email (In this section the answer must be an email)',
})

extend('password', {
  validate: (value, { other }) => value === other,
  message:
    'Pada bagian ini password konfirmasi harus Sama (In this section the confirmation password must be the same).',
  params: [{ name: 'other', isTarget: true }],
})

extend('minsecond', {
  params: ['min'],
  validate(value, { min }) {
    return value >= min
  },
  message:
    'Pada bagian ini harus minimal {min} detik (In this section it must be a minimum {min} seconds)',
})

extend('min', {
  params: ['min'],
  validate(value, { min }) {
    return value > min
  },
  message:
    'Pada bagian ini harus minimal {min} (In this section it must be minimal {min})',
})

extend('max', {
  params: ['max'],
  validate(value, { max }) {
    return value < max
  },
  message:
    'Pada bagian ini harus maximum {max} (In this section must be maximum {max})',
})

extend('requiredarray', {
  ...required,
  validate(value) {
    return value.length >= 1
  },
  message: 'Bagian ini wajib diisi (This section must be filled)',
})

extend('requiredarraybetween', {
  params: ['min', 'max'],
  validate(value, { min, max }) {
    var result = value.length >= min && value.length <= max
    return result
  },
  message:
    'Pada bagian ini harus diisi antara {min} dan {max} jawaban (This section must be filled in between {min} and {max} answer)',
})

extend('betweenchar', {
  params: ['rules'],
  validate(value, { rules }) {
    return value.length >= rules.min && value.length <= rules.max
  },
  message:
    'Pada bagian ini harus mengisikan minimum dan maksimum karakter-karakter yang akan di input (In this section must fill in the minimum and maximum characters to be input)',
})

extend('minchar', {
  params: ['min'],
  validate(value, { min }) {
    return value.length >= min
  },
  message:
    'Pada bagian ini harus minimal {min} karakter (In this section it must be a minimum {min} character)',
})

extend('maxchar', {
  params: ['max'],
  validate(value, { max }) {
    return value.length <= max
  },
  message:
    'Pada bagian ini harus maximum {max} karakter (In this section must be maximum {max} character)',
})

extend('betweenword', {
  params: ['rules'],
  validate(value, { rules }) {
    let arrayWord = value.replace(/\s+/g, ' ').split(' ')
    return (
      arrayWord.length >= rules.min &&
      arrayWord.length <= rules.max &&
      arrayWord[rules.min - 1] != ''
    )
  },
  message:
    'Pada bagian ini harus mengisikan minimum dan maksimum kata-kata yang akan di input (In this section must fill in the minimum and maximum words to be input)',
})

extend('minword', {
  params: ['minword'],
  validate(value, { minword }) {
    let arrayWord = value.replace(/\s+/g, ' ').split(' ')
    return arrayWord.length >= minword && arrayWord[minword - 1] != ''
  },
  message:
    'Pada bagian ini harus maksimum {minword} kata (This section must be maximum {minword} word)',
})

extend('maxword', {
  params: ['maxword'],
  validate(value, { maxword }) {
    let arrayWord = value.replace(/\s+/g, ' ').split(' ')
    return arrayWord.length <= maxword
  },
  message:
    'Pada bagian ini harus maksimum {maxword} kata (This section must be maximum {maxword} word)',
})

extend('required', {
  ...required,
  message: 'Bagian ini wajib diisi (This section must be filled)',
})

extend('checkboxmax', {
  params: ['max'],
  validate(value, { max }) {
    return value.length <= max
  },
  message:
    'Wajib memilih maksimum {max} pilihan jawaban (Must choose maximum {max} answer choices)',
})

extend('checkboxmin', {
  params: ['min'],
  validate(value, { min }) {
    return value.length >= min
  },
  message:
    'Wajib memilih minimal {min} pilihan jawaban (Must choose a minimum {min} Answer Options)',
})

ApiService.init()
Vue.use(NotificationPlugin)

const app = new Vue({
  router,
  store,
  Buefy,
  render: h => h(App),
}).$mount('#app')

// 3. Expose root instance separately for notifications
window.VueRoot = app

window.$ = window.jQuery = require('jquery')
